<svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8">
    <path fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="square" stroke-width="1.587" d="M10.5 1.5L6 6.5l-4.5-5"/>
</svg>
